module.exports = __webpack_public_path__ + "static/media/simple_es.e17648d6.svg";